/* tslint:disable */
/* eslint-disable */
/**
 * Control WebService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLocality': string;
    /**
     * 
     * @type {Country}
     * @memberof Address
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AddressIndebtedOrganization
 */
export interface AddressIndebtedOrganization {
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressLocality': string;
    /**
     * 
     * @type {Country}
     * @memberof AddressIndebtedOrganization
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AddressOrganization
 */
export interface AddressOrganization {
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressLocality'?: string;
    /**
     * 
     * @type {Country}
     * @memberof AddressOrganization
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AgentSelfStatistics
 */
export interface AgentSelfStatistics {
    /**
     * 
     * @type {number}
     * @memberof AgentSelfStatistics
     */
    'averageControlDuration'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentSelfStatistics
     */
    'controlCount'?: number;
}
/**
 * 
 * @export
 * @interface AgentsStatisticsInner
 */
export interface AgentsStatisticsInner {
    /**
     * 
     * @type {string}
     * @memberof AgentsStatisticsInner
     */
    'agentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentsStatisticsInner
     */
    'processed'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentsStatisticsInner
     */
    'emittedFps'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentsStatisticsInner
     */
    'emittedNfps'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentsStatisticsInner
     */
    'agentSent'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentsStatisticsInner
     */
    'averageControlDuration'?: number;
}
/**
 * 
 * @export
 * @interface Alive
 */
export interface Alive {
    /**
     * 
     * @type {string}
     * @memberof Alive
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Alive
     */
    'version'?: string;
    /**
     * Server current date, ISO-8601
     * @type {string}
     * @memberof Alive
     */
    'currentDate'?: string;
    /**
     * Time since starting, in milliseconds
     * @type {number}
     * @memberof Alive
     */
    'aliveSince'?: number;
    /**
     * Current server hostname, useful on distributed architectures
     * @type {string}
     * @memberof Alive
     */
    'hostname'?: string;
    /**
     * Pending control assignation requests in queue
     * @type {number}
     * @memberof Alive
     */
    'queuelength'?: number;
}
/**
 * 
 * @export
 * @interface AntaiError
 */
export interface AntaiError {
    /**
     * 
     * @type {Array<AntaiErrorErrorsInner>}
     * @memberof AntaiError
     */
    'errors'?: Array<AntaiErrorErrorsInner>;
}
/**
 * 
 * @export
 * @interface AntaiErrorErrorsInner
 */
export interface AntaiErrorErrorsInner {
    /**
     * 
     * @type {string}
     * @memberof AntaiErrorErrorsInner
     */
    'code'?: AntaiErrorErrorsInnerCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof AntaiErrorErrorsInner
     */
    'type'?: string;
}

export const AntaiErrorErrorsInnerCodeEnum = {
    _1002: '1002',
    _1003: '1003',
    _1004: '1004',
    _1005: '1005',
    _1006: '1006',
    _1007: '1007',
    _1008: '1008',
    _1009: '1009',
    _1010: '1010',
    _1011: '1011',
    _1012: '1012',
    _1013: '1013',
    _1014: '1014',
    _1015: '1015'
} as const;

export type AntaiErrorErrorsInnerCodeEnum = typeof AntaiErrorErrorsInnerCodeEnum[keyof typeof AntaiErrorErrorsInnerCodeEnum];

/**
 * 
 * @export
 * @interface Control
 */
export interface Control {
    /**
     * Identifiant unique du contrôle
     * @type {string}
     * @memberof Control
     */
    'controlId': string;
    /**
     * Date du contrôle
     * @type {string}
     * @memberof Control
     */
    'controlDate': string;
    /**
     * Date et heure d\'expiration du contrôle
     * @type {string}
     * @memberof Control
     */
    'expiresAt'?: string;
    /**
     * Plaque d\'immatriculation
     * @type {string}
     * @memberof Control
     */
    'licensePlate': string;
    /**
     * id de l\'agent auquel a été assigné le contrôle
     * @type {string}
     * @memberof Control
     */
    'agentId'?: string;
    /**
     * Identifiant unique de l\'utilisateur
     * @type {string}
     * @memberof Control
     */
    'userId': string;
    /**
     * Identifiant unique du terminal
     * @type {string}
     * @memberof Control
     */
    'terminalId': string;
    /**
     * Identifiant unique généré par un vecule LAPI permettant de récupérer les photos d\'un contrôle
     * @type {string}
     * @memberof Control
     */
    'transitId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'longitude'?: number;
    /**
     * 
     * @type {Priority & object}
     * @memberof Control
     */
    'priority'?: Priority & object;
    /**
     * 
     * @type {Validity}
     * @memberof Control
     */
    'validity'?: Validity;
    /**
     * 
     * @type {Progress & object}
     * @memberof Control
     */
    'progress'?: Progress & object;
    /**
     * 
     * @type {State & object}
     * @memberof Control
     */
    'state'?: State & object;
    /**
     * Tickets du contrôle
     * @type {Array<Ticket2>}
     * @memberof Control
     */
    'tickets'?: Array<Ticket2>;
    /**
     * 
     * @type {ControlType}
     * @memberof Control
     */
    'type': ControlType;
    /**
     * Fiabilité générale de la détection (en pourcentage) compris entre 0 et 1
     * @type {number}
     * @memberof Control
     */
    'genReliability'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Control
     */
    'charReliability'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'gpsHeading'?: number;
    /**
     * pdop de la mesure du gps
     * @type {number}
     * @memberof Control
     */
    'gpsPdop'?: number;
    /**
     * Précision du gps en mètre
     * @type {number}
     * @memberof Control
     */
    'accuracy'?: number;
    /**
     * Nom du fichier de la photo de la plaque d\'immatriculation
     * @type {string}
     * @memberof Control
     */
    'platePicture'?: string;
    /**
     * Noms des fichiers des photos de contexte du contrôle
     * @type {Array<string>}
     * @memberof Control
     */
    'contextPictures'?: Array<string>;
    /**
     * Permet le stockage d\'information complémentaires associées au contrôle. Sous forme de JSON ou de string representant un JSON
     * @type {object}
     * @memberof Control
     */
    'metadata'?: object;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'emitterLatitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'emitterLongitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'emitterGpsHeading'?: number;
    /**
     * 
     * @type {number}
     * @memberof Control
     */
    'emitterGpsPdop'?: number;
    /**
     * 
     * @type {CountryAlpha2}
     * @memberof Control
     */
    'plateCountry'?: CountryAlpha2;
    /**
     * 
     * @type {string}
     * @memberof Control
     */
    'plateCountryIvrc'?: string;
    /**
     * 
     * @type {string}
     * @memberof Control
     */
    'vehicleCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof Control
     */
    'vehicleBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof Control
     */
    'vehicleModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof Control
     */
    'plateType'?: string;
}
/**
 * 
 * @export
 * @interface ControlAdditionalData
 */
export interface ControlAdditionalData {
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalData
     */
    'plate'?: string;
    /**
     * 
     * @type {ControlAdditionalDataRecord}
     * @memberof ControlAdditionalData
     */
    'country'?: ControlAdditionalDataRecord;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalData
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {VehicleTypeRecord}
     * @memberof ControlAdditionalData
     */
    'vehicleType'?: VehicleTypeRecord;
    /**
     * 
     * @type {ControlAdditionalDataRecord}
     * @memberof ControlAdditionalData
     */
    'brand'?: ControlAdditionalDataRecord;
    /**
     * 
     * @type {ControlAdditionalDataRecord}
     * @memberof ControlAdditionalData
     */
    'model'?: ControlAdditionalDataRecord;
    /**
     * 
     * @type {ControlAdditionalDataPosition}
     * @memberof ControlAdditionalData
     */
    'position'?: ControlAdditionalDataPosition;
    /**
     * 
     * @type {IdLessControlAdditionalDataRecord}
     * @memberof ControlAdditionalData
     */
    'zone'?: IdLessControlAdditionalDataRecord;
    /**
     * 
     * @type {IdLessControlAdditionalDataRecord}
     * @memberof ControlAdditionalData
     */
    'sector'?: IdLessControlAdditionalDataRecord;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalData
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalData
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalData
     */
    'city'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlAdditionalData
     */
    'mediasUrl'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ControlAdditionalDataPosition
 */
export interface ControlAdditionalDataPosition {
    /**
     * 
     * @type {number}
     * @memberof ControlAdditionalDataPosition
     */
    'lon': number;
    /**
     * 
     * @type {number}
     * @memberof ControlAdditionalDataPosition
     */
    'lat': number;
}
/**
 * 
 * @export
 * @interface ControlAdditionalDataRecord
 */
export interface ControlAdditionalDataRecord {
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalDataRecord
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalDataRecord
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAdditionalDataRecord
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ControlResultFps
 */
export interface ControlResultFps {
    /**
     * 
     * @type {FPS}
     * @memberof ControlResultFps
     */
    'fpsData': FPS;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlResultFps
     */
    'mediasUrl': Array<string>;
}
/**
 * 
 * @export
 * @interface ControlResultNfps
 */
export interface ControlResultNfps {
    /**
     * 
     * @type {EmitNfpsBody}
     * @memberof ControlResultNfps
     */
    'nfpsData': EmitNfpsBody;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlResultNfps
     */
    'mediasUrl': Array<string>;
}
/**
 * Type de contrôle
 * @export
 * @enum {string}
 */

export const ControlType = {
    PDA: 'PDA',
    LAPI: 'LAPI'
} as const;

export type ControlType = typeof ControlType[keyof typeof ControlType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Country = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BQ: 'BQ',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CW: 'CW',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    SS: 'SS',
    ST: 'ST',
    SV: 'SV',
    SX: 'SX',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

export type Country = typeof Country[keyof typeof Country];


/**
 * ISO 3166-1 Alpha 2 country code
 * @export
 * @enum {string}
 */

export const CountryAlpha2 = {
    null: 'null',
    AF: 'AF',
    AX: 'AX',
    AL: 'AL',
    DZ: 'DZ',
    AS: 'AS',
    AD: 'AD',
    AO: 'AO',
    AI: 'AI',
    AQ: 'AQ',
    AG: 'AG',
    AR: 'AR',
    AM: 'AM',
    AW: 'AW',
    AU: 'AU',
    AT: 'AT',
    AZ: 'AZ',
    BS: 'BS',
    BH: 'BH',
    BD: 'BD',
    BB: 'BB',
    BY: 'BY',
    BE: 'BE',
    BZ: 'BZ',
    BJ: 'BJ',
    BM: 'BM',
    BT: 'BT',
    BO: 'BO',
    BA: 'BA',
    BW: 'BW',
    BV: 'BV',
    BR: 'BR',
    IO: 'IO',
    BN: 'BN',
    BG: 'BG',
    BF: 'BF',
    BI: 'BI',
    KH: 'KH',
    CM: 'CM',
    CA: 'CA',
    CV: 'CV',
    KY: 'KY',
    CF: 'CF',
    TD: 'TD',
    CL: 'CL',
    CN: 'CN',
    CX: 'CX',
    CC: 'CC',
    CO: 'CO',
    KM: 'KM',
    CG: 'CG',
    CD: 'CD',
    CK: 'CK',
    CR: 'CR',
    CI: 'CI',
    HR: 'HR',
    CU: 'CU',
    CY: 'CY',
    CZ: 'CZ',
    DK: 'DK',
    DJ: 'DJ',
    DM: 'DM',
    DO: 'DO',
    EC: 'EC',
    EG: 'EG',
    SV: 'SV',
    GQ: 'GQ',
    ER: 'ER',
    EE: 'EE',
    ET: 'ET',
    FK: 'FK',
    FO: 'FO',
    FJ: 'FJ',
    FI: 'FI',
    FR: 'FR',
    GF: 'GF',
    PF: 'PF',
    TF: 'TF',
    GA: 'GA',
    GM: 'GM',
    GE: 'GE',
    DE: 'DE',
    GH: 'GH',
    GI: 'GI',
    GR: 'GR',
    GL: 'GL',
    GD: 'GD',
    GP: 'GP',
    GU: 'GU',
    GT: 'GT',
    GG: 'GG',
    GN: 'GN',
    GW: 'GW',
    GY: 'GY',
    HT: 'HT',
    HM: 'HM',
    VA: 'VA',
    HN: 'HN',
    HK: 'HK',
    HU: 'HU',
    IS: 'IS',
    IN: 'IN',
    ID: 'ID',
    IR: 'IR',
    IQ: 'IQ',
    IE: 'IE',
    IM: 'IM',
    IL: 'IL',
    IT: 'IT',
    JM: 'JM',
    JP: 'JP',
    JE: 'JE',
    JO: 'JO',
    KZ: 'KZ',
    KE: 'KE',
    KI: 'KI',
    KR: 'KR',
    KP: 'KP',
    KW: 'KW',
    KG: 'KG',
    LA: 'LA',
    LV: 'LV',
    LB: 'LB',
    LS: 'LS',
    LR: 'LR',
    LY: 'LY',
    LI: 'LI',
    LT: 'LT',
    LU: 'LU',
    MO: 'MO',
    MK: 'MK',
    MG: 'MG',
    MW: 'MW',
    MY: 'MY',
    MV: 'MV',
    ML: 'ML',
    MT: 'MT',
    MH: 'MH',
    MQ: 'MQ',
    MR: 'MR',
    MU: 'MU',
    YT: 'YT',
    MX: 'MX',
    FM: 'FM',
    MD: 'MD',
    MC: 'MC',
    MN: 'MN',
    ME: 'ME',
    MS: 'MS',
    MA: 'MA',
    MZ: 'MZ',
    MM: 'MM',
    NA: 'NA',
    NR: 'NR',
    NP: 'NP',
    NL: 'NL',
    AN: 'AN',
    NC: 'NC',
    NZ: 'NZ',
    NI: 'NI',
    NE: 'NE',
    NG: 'NG',
    NU: 'NU',
    NF: 'NF',
    MP: 'MP',
    NO: 'NO',
    OM: 'OM',
    PK: 'PK',
    PW: 'PW',
    PS: 'PS',
    PA: 'PA',
    PG: 'PG',
    PY: 'PY',
    PE: 'PE',
    PH: 'PH',
    PN: 'PN',
    PL: 'PL',
    PT: 'PT',
    PR: 'PR',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RU: 'RU',
    RW: 'RW',
    BL: 'BL',
    SH: 'SH',
    KN: 'KN',
    LC: 'LC',
    MF: 'MF',
    PM: 'PM',
    VC: 'VC',
    WS: 'WS',
    SM: 'SM',
    ST: 'ST',
    SA: 'SA',
    SN: 'SN',
    RS: 'RS',
    SC: 'SC',
    SL: 'SL',
    SG: 'SG',
    SK: 'SK',
    SI: 'SI',
    SB: 'SB',
    SO: 'SO',
    ZA: 'ZA',
    GS: 'GS',
    ES: 'ES',
    LK: 'LK',
    SD: 'SD',
    SR: 'SR',
    SJ: 'SJ',
    SZ: 'SZ',
    SE: 'SE',
    CH: 'CH',
    SY: 'SY',
    TW: 'TW',
    TJ: 'TJ',
    TZ: 'TZ',
    TH: 'TH',
    TL: 'TL',
    TG: 'TG',
    TK: 'TK',
    TO: 'TO',
    TT: 'TT',
    TN: 'TN',
    TR: 'TR',
    TM: 'TM',
    TC: 'TC',
    TV: 'TV',
    UG: 'UG',
    UA: 'UA',
    AE: 'AE',
    GB: 'GB',
    US: 'US',
    UM: 'UM',
    UY: 'UY',
    UZ: 'UZ',
    VU: 'VU',
    VE: 'VE',
    VN: 'VN',
    VG: 'VG',
    VI: 'VI',
    WF: 'WF',
    EH: 'EH',
    YE: 'YE',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

export type CountryAlpha2 = typeof CountryAlpha2[keyof typeof CountryAlpha2];


/**
 * 
 * @export
 * @interface DecisionActivityInner
 */
export interface DecisionActivityInner {
    /**
     * 
     * @type {string}
     * @memberof DecisionActivityInner
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof DecisionActivityInner
     */
    'FPS'?: number;
    /**
     * 
     * @type {number}
     * @memberof DecisionActivityInner
     */
    'NFPS'?: number;
    /**
     * 
     * @type {number}
     * @memberof DecisionActivityInner
     */
    'VERIFY'?: number;
}
/**
 * 
 * @export
 * @interface DecisionPayload
 */
export interface DecisionPayload {
    /**
     * 
     * @type {string}
     * @memberof DecisionPayload
     */
    'type'?: DecisionPayloadTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof DecisionPayload
     */
    'payload'?: object;
}

export const DecisionPayloadTypeEnum = {
    FPS: 'FPS',
    NFPS: 'NFPS'
} as const;

export type DecisionPayloadTypeEnum = typeof DecisionPayloadTypeEnum[keyof typeof DecisionPayloadTypeEnum];

/**
 * 
 * @export
 * @interface DecisionsCount
 */
export interface DecisionsCount {
    /**
     * 
     * @type {number}
     * @memberof DecisionsCount
     */
    'FPS'?: number;
    /**
     * 
     * @type {number}
     * @memberof DecisionsCount
     */
    'NFPS'?: number;
    /**
     * 
     * @type {number}
     * @memberof DecisionsCount
     */
    'VERIFY'?: number;
}
/**
 * 
 * @export
 * @interface DecisionsStatistics
 */
export interface DecisionsStatistics {
    /**
     * 
     * @type {DecisionsStatisticsQuery}
     * @memberof DecisionsStatistics
     */
    'query'?: DecisionsStatisticsQuery;
    /**
     * 
     * @type {DecisionsCount}
     * @memberof DecisionsStatistics
     */
    'total'?: DecisionsCount;
    /**
     * 
     * @type {Array<DecisionActivityInner>}
     * @memberof DecisionsStatistics
     */
    'activity'?: Array<DecisionActivityInner>;
}
/**
 * 
 * @export
 * @interface DecisionsStatisticsQuery
 */
export interface DecisionsStatisticsQuery {
    /**
     * 
     * @type {string}
     * @memberof DecisionsStatisticsQuery
     */
    'start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecisionsStatisticsQuery
     */
    'end'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecisionsStatisticsQuery
     */
    'query'?: DecisionsStatisticsQueryQueryEnum;
}

export const DecisionsStatisticsQueryQueryEnum = {
    day: 'day',
    hour: 'hour'
} as const;

export type DecisionsStatisticsQueryQueryEnum = typeof DecisionsStatisticsQueryQueryEnum[keyof typeof DecisionsStatisticsQueryQueryEnum];

/**
 * 
 * @export
 * @interface EmitNfpsBody
 */
export interface EmitNfpsBody {
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBody
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBody
     */
    'matricule'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBody
     */
    'date': string;
    /**
     * 
     * @type {EmitNfpsBodyPosition}
     * @memberof EmitNfpsBody
     */
    'position'?: EmitNfpsBodyPosition;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBody
     */
    'type'?: EmitNfpsBodyTypeEnum;
    /**
     * 
     * @type {EmitNfpsBodyParams}
     * @memberof EmitNfpsBody
     */
    'params': EmitNfpsBodyParams;
}

export const EmitNfpsBodyTypeEnum = {
    NFPS: 'NFPS'
} as const;

export type EmitNfpsBodyTypeEnum = typeof EmitNfpsBodyTypeEnum[keyof typeof EmitNfpsBodyTypeEnum];

/**
 * 
 * @export
 * @interface EmitNfpsBodyParams
 */
export interface EmitNfpsBodyParams {
    /**
     * 
     * @type {ExemptionReason}
     * @memberof EmitNfpsBodyParams
     */
    'exemptionReason': ExemptionReason;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'zoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'parkId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'licensePlate': string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'vehicleCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'vehicleModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmitNfpsBodyParams
     */
    'vehicleBrand'?: string;
    /**
     * 
     * @type {Array<SignificantRight>}
     * @memberof EmitNfpsBodyParams
     */
    'parkingRightHistory': Array<SignificantRight>;
    /**
     * 
     * @type {Country}
     * @memberof EmitNfpsBodyParams
     */
    'plateCountry'?: Country;
}
/**
 * 
 * @export
 * @interface EmitNfpsBodyPosition
 */
export interface EmitNfpsBodyPosition {
    /**
     * 
     * @type {number}
     * @memberof EmitNfpsBodyPosition
     */
    'lon': number;
    /**
     * 
     * @type {number}
     * @memberof EmitNfpsBodyPosition
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof EmitNfpsBodyPosition
     */
    'acc': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ExemptionReason = {
    mobility: 'mobility',
    presence: 'presence',
    aggression: 'aggression',
    typo: 'typo',
    authorization: 'authorization',
    diplomat: 'diplomat',
    troublesome: 'troublesome',
    roadwork: 'roadwork',
    grace: 'grace',
    user_at_the_parking_meter: 'user_at_the_parking_meter',
    free: 'free',
    no_marking: 'no_marking',
    out_of_order: 'out_of_order',
    other: 'other'
} as const;

export type ExemptionReason = typeof ExemptionReason[keyof typeof ExemptionReason];


/**
 * Format pour la creation d\'un FPS
 * @export
 * @interface FPS
 */
export interface FPS {
    /**
     * 
     * @type {FPSAgent}
     * @memberof FPS
     */
    'agent': FPSAgent;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'authId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'authTransfertDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'cityId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'fineLegalId': string;
    /**
     * 
     * @type {number}
     * @memberof FPS
     */
    'finePrice': number;
    /**
     * 
     * @type {FPSLicensePlate}
     * @memberof FPS
     */
    'licensePlate': FPSLicensePlate;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'notificationAuthority': FPSNotificationAuthorityEnum;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'notificationDatetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'parkId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'parent'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'paymentStatus': FPSPaymentStatusEnum;
    /**
     * 
     * @type {Organization}
     * @memberof FPS
     */
    'recourseOrganization': Organization;
    /**
     * 
     * @type {PersonOrOrganization}
     * @memberof FPS
     */
    'offender'?: PersonOrOrganization;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'reducedDatetime'?: string;
    /**
     * 
     * @type {number}
     * @memberof FPS
     */
    'reducedFinePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'rootFineLegalId'?: string;
    /**
     * 
     * @type {Array<SignificantRight>}
     * @memberof FPS
     */
    'significantRights'?: Array<SignificantRight>;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'statementDatetime': string;
    /**
     * 
     * @type {Location}
     * @memberof FPS
     */
    'statementLocation'?: Location;
    /**
     * 
     * @type {Address}
     * @memberof FPS
     */
    'statementAddress': Address;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'terminalId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'type': FPSTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'validityDatetime': string;
    /**
     * 
     * @type {FPSVehicle}
     * @memberof FPS
     */
    'vehicle': FPSVehicle;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'zoneId': string;
    /**
     * 
     * @type {object}
     * @memberof FPS
     */
    'comments'?: object;
}

export const FPSNotificationAuthorityEnum = {
    LOCAL: 'LOCAL',
    ANTAI: 'ANTAI'
} as const;

export type FPSNotificationAuthorityEnum = typeof FPSNotificationAuthorityEnum[keyof typeof FPSNotificationAuthorityEnum];
export const FPSPaymentStatusEnum = {
    PENDING: 'PENDING'
} as const;

export type FPSPaymentStatusEnum = typeof FPSPaymentStatusEnum[keyof typeof FPSPaymentStatusEnum];
export const FPSTypeEnum = {
    INITIAL: 'INITIAL',
    CORRECTION: 'CORRECTION',
    CANCELLED: 'CANCELLED'
} as const;

export type FPSTypeEnum = typeof FPSTypeEnum[keyof typeof FPSTypeEnum];

/**
 * 
 * @export
 * @interface FPSAgent
 */
export interface FPSAgent {
    /**
     * 
     * @type {string}
     * @memberof FPSAgent
     */
    'agentId': string;
    /**
     * 
     * @type {string}
     * @memberof FPSAgent
     */
    'name': string;
    /**
     * 
     * @type {Organization}
     * @memberof FPSAgent
     */
    'worksFor': Organization;
}
/**
 * 
 * @export
 * @interface FPSLicensePlate
 */
export interface FPSLicensePlate {
    /**
     * 
     * @type {string}
     * @memberof FPSLicensePlate
     */
    'plate': string;
    /**
     * 
     * @type {string}
     * @memberof FPSLicensePlate
     */
    'pricingCategory'?: string;
    /**
     * 
     * @type {Country}
     * @memberof FPSLicensePlate
     */
    'plateCountry': Country;
}
/**
 * 
 * @export
 * @interface FPSVehicle
 */
export interface FPSVehicle {
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'vehiculeCategory'?: string;
}
/**
 * 
 * @export
 * @interface IdLessControlAdditionalDataRecord
 */
export interface IdLessControlAdditionalDataRecord {
    /**
     * 
     * @type {string}
     * @memberof IdLessControlAdditionalDataRecord
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdLessControlAdditionalDataRecord
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface IrControlErrorMessage
 */
export interface IrControlErrorMessage {
    /**
     * 
     * @type {string}
     * @memberof IrControlErrorMessage
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof IrControlErrorMessage
     */
    'description'?: string;
    /**
     * 
     * @type {object}
     * @memberof IrControlErrorMessage
     */
    'reason'?: object;
}
/**
 * 
 * @export
 * @interface LapiControl
 */
export interface LapiControl {
    /**
     * Database entry ID
     * @type {string}
     * @memberof LapiControl
     */
    'id'?: string;
    /**
     * Database entry\'s revision ID
     * @type {string}
     * @memberof LapiControl
     */
    '_rev'?: string;
    /**
     * Identificateur unique d\'utilisateur
     * @type {string}
     * @memberof LapiControl
     */
    'user_id': string;
    /**
     * Identificateur unique du véhicule
     * @type {string}
     * @memberof LapiControl
     */
    'vehicle_id': string;
    /**
     * Catégorie du véhicule
     * @type {string}
     * @memberof LapiControl
     */
    'vehicle_category'?: string;
    /**
     * Marque du véhicule
     * @type {string}
     * @memberof LapiControl
     */
    'vehicle_brand'?: string;
    /**
     * Modèle du véhicule
     * @type {string}
     * @memberof LapiControl
     */
    'vehicle_model'?: string;
    /**
     * Identificateur unique du véhicule
     * @type {string}
     * @memberof LapiControl
     */
    'transit_id'?: string;
    /**
     * Plaque d\'immatriculation
     * @type {string}
     * @memberof LapiControl
     */
    'plate': string;
    /**
     * Pays de la plaque d\'immatriculation du véhicule au format alpha-2
     * @type {string}
     * @memberof LapiControl
     */
    'plate_country'?: string;
    /**
     * Fiabilité générale de la détection (en pourcentage)
     * @type {number}
     * @memberof LapiControl
     */
    'gen_reliability': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof LapiControl
     */
    'char_reliability': Array<number>;
    /**
     * date du contrôle
     * @type {string}
     * @memberof LapiControl
     */
    'date': string;
    /**
     * latitude
     * @type {number}
     * @memberof LapiControl
     */
    'gps_latitude': number;
    /**
     * longitude
     * @type {number}
     * @memberof LapiControl
     */
    'gps_longitude': number;
    /**
     * direction du gps
     * @type {number}
     * @memberof LapiControl
     */
    'gps_heading'?: number;
    /**
     * pdop de la mesure du gps
     * @type {number}
     * @memberof LapiControl
     */
    'gps_pdop': number;
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof LapiControl
     */
    'tickets'?: Array<Ticket>;
    /**
     * 
     * @type {string}
     * @memberof LapiControl
     */
    'progress'?: LapiControlProgressEnum;
    /**
     * 
     * @type {string}
     * @memberof LapiControl
     */
    'status'?: LapiControlStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof LapiControl
     */
    'plate_image'?: string;
    /**
     * 
     * @type {Array<LapiControlPanoImageInner>}
     * @memberof LapiControl
     */
    'pano_image'?: Array<LapiControlPanoImageInner>;
}

export const LapiControlProgressEnum = {
    INCOMPLETE: 'INCOMPLETE',
    REVIEWABLE: 'REVIEWABLE',
    EXPIRED: 'EXPIRED'
} as const;

export type LapiControlProgressEnum = typeof LapiControlProgressEnum[keyof typeof LapiControlProgressEnum];
export const LapiControlStatusEnum = {
    VALID: 'VALID',
    INVALID: 'INVALID'
} as const;

export type LapiControlStatusEnum = typeof LapiControlStatusEnum[keyof typeof LapiControlStatusEnum];

/**
 * 
 * @export
 * @interface LapiControlPanoImageInner
 */
export interface LapiControlPanoImageInner {
    /**
     * 
     * @type {string}
     * @memberof LapiControlPanoImageInner
     */
    'camera_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LapiControlPanoImageInner
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof LapiControlPanoImageInner
     */
    'thumbnail'?: string;
}
/**
 * 
 * @export
 * @interface LapiStatisticsInner
 */
export interface LapiStatisticsInner {
    /**
     * 
     * @type {string}
     * @memberof LapiStatisticsInner
     */
    'lapiId'?: string;
    /**
     * 
     * @type {number}
     * @memberof LapiStatisticsInner
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof LapiStatisticsInner
     */
    'processed'?: number;
    /**
     * 
     * @type {number}
     * @memberof LapiStatisticsInner
     */
    'expired'?: number;
    /**
     * 
     * @type {number}
     * @memberof LapiStatisticsInner
     */
    'pending'?: number;
    /**
     * 
     * @type {number}
     * @memberof LapiStatisticsInner
     */
    'under15mins'?: number;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'altitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'incertitude'?: number;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'url'?: string;
    /**
     * 
     * @type {AddressOrganization}
     * @memberof Organization
     */
    'address': AddressOrganization;
}
/**
 * 
 * @export
 * @interface PersonOrOrganization
 */
export interface PersonOrOrganization {
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'organizationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'gender'?: PersonOrOrganizationGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'honorificPrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'additionalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'maidenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'familyName'?: string;
    /**
     * 
     * @type {AddressIndebtedOrganization}
     * @memberof PersonOrOrganization
     */
    'address': AddressIndebtedOrganization;
}

export const PersonOrOrganizationGenderEnum = {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
} as const;

export type PersonOrOrganizationGenderEnum = typeof PersonOrOrganizationGenderEnum[keyof typeof PersonOrOrganizationGenderEnum];

/**
 * Priorité du contrôle
 * @export
 * @enum {string}
 */

export const Priority = {
    LOW: 'LOW',
    HIGH: 'HIGH'
} as const;

export type Priority = typeof Priority[keyof typeof Priority];


/**
 * Progression de l\'envoi des photos du contrôle
 * @export
 * @enum {string}
 */

export const Progress = {
    INCOMPLETE: 'INCOMPLETE',
    COMPLETE: 'COMPLETE'
} as const;

export type Progress = typeof Progress[keyof typeof Progress];


/**
 * 
 * @export
 * @interface SignificantRight
 */
export interface SignificantRight {
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'type': SignificantRightTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'cityId': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'endDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'fineId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'fineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'parkId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SignificantRight
     */
    'rightPrice': number;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'rootFineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'startDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'zoneId'?: string;
}

export const SignificantRightTypeEnum = {
    FINE: 'FINE',
    TICKET: 'TICKET',
    CONTRACT: 'CONTRACT',
    FREE: 'FREE',
    OTHER: 'OTHER'
} as const;

export type SignificantRightTypeEnum = typeof SignificantRightTypeEnum[keyof typeof SignificantRightTypeEnum];

/**
 * 
 * @export
 * @interface SkipControlBody
 */
export interface SkipControlBody {
    /**
     * 
     * @type {string}
     * @memberof SkipControlBody
     */
    'validity'?: SkipControlBodyValidityEnum;
    /**
     * 
     * @type {Array<Ticket>}
     * @memberof SkipControlBody
     */
    'tickets': Array<Ticket>;
    /**
     * 
     * @type {string}
     * @memberof SkipControlBody
     */
    'vehicleCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof SkipControlBody
     */
    'vehicleModel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SkipControlBody
     */
    'vehicleBrand'?: string;
    /**
     * 
     * @type {number}
     * @memberof SkipControlBody
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof SkipControlBody
     */
    'longitude'?: number;
    /**
     * 
     * @type {SkipControlBodyLicensePlate}
     * @memberof SkipControlBody
     */
    'licensePlate'?: SkipControlBodyLicensePlate;
}

export const SkipControlBodyValidityEnum = {
    VALID: 'VALID',
    INVALID: 'INVALID'
} as const;

export type SkipControlBodyValidityEnum = typeof SkipControlBodyValidityEnum[keyof typeof SkipControlBodyValidityEnum];

/**
 * 
 * @export
 * @interface SkipControlBodyLicensePlate
 */
export interface SkipControlBodyLicensePlate {
    /**
     * 
     * @type {string}
     * @memberof SkipControlBodyLicensePlate
     */
    'plate'?: string;
    /**
     * 
     * @type {Country}
     * @memberof SkipControlBodyLicensePlate
     */
    'plateCountry'?: Country;
}
/**
 * État du contrôle
 * @export
 * @enum {string}
 */

export const State = {
    NEW: 'NEW',
    WAITING: 'WAITING',
    ASSIGNED: 'ASSIGNED',
    WORKING: 'WORKING',
    PROCESSING: 'PROCESSING',
    FINISHED: 'FINISHED',
    VERIFY: 'VERIFY',
    EXPIRED: 'EXPIRED'
} as const;

export type State = typeof State[keyof typeof State];


/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * Identifiant unique du ticket en base de donnée
     * @type {string}
     * @memberof Ticket
     */
    '_id'?: string;
    /**
     * Révision du document
     * @type {string}
     * @memberof Ticket
     */
    '_rev'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'profile': TicketProfileEnum;
    /**
     * Code tariffaire de validité du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'tariffCode'?: string;
    /**
     * Lieux de résidence de validité du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'locationCode'?: string;
    /**
     * Identifiant de l\'opérateur.
     * @type {number}
     * @memberof Ticket
     */
    'operatorId': number;
    /**
     * Identifiant unique du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'systemId': string;
    /**
     * Plaque d\'immatriculation associé au ticket.
     * @type {string}
     * @memberof Ticket
     */
    'licensePlate'?: string;
    /**
     * Plaque d\'immatriculation associé au ticket.
     * @type {string}
     * @memberof Ticket
     */
    'licensePlateHash'?: string;
    /**
     * Date de début du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'startDateTime': string;
    /**
     * Date de fin du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'endDateTime': string;
    /**
     * Date de creation du ticket.
     * @type {string}
     * @memberof Ticket
     */
    'createdAt': string;
    /**
     * Durée du ticket.
     * @type {number}
     * @memberof Ticket
     */
    'paidMinutes': number;
    /**
     * Montant du ticket (en centimes dans le cas ou amountCurrency a la valeur EUR)
     * @type {number}
     * @memberof Ticket
     */
    'amountPaid': number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'amountCurrency': string;
    /**
     * Indique si le ticket est à prendre en compte lors du calcul du montant du FPS
     * @type {boolean}
     * @memberof Ticket
     */
    'isSignificant': boolean;
}

export const TicketProfileEnum = {
    VIS: 'VIS',
    FPS: 'FPS',
    PMR: 'PMR',
    RES: 'RES',
    PRO_M: 'PRO-M',
    PRO_S: 'PRO-S',
    PRO_P: 'PRO-P',
    VP: 'VP'
} as const;

export type TicketProfileEnum = typeof TicketProfileEnum[keyof typeof TicketProfileEnum];

/**
 * 
 * @export
 * @interface Ticket2
 */
export interface Ticket2 {
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'amountCurrency'?: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket2
     */
    'amountPaid'?: number;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'endDateTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ticket2
     */
    'isSignificant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'licensePlate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'licensePlateHash'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'locationCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof Ticket2
     */
    'operatorId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Ticket2
     */
    'paidMinutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'profile'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'startDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'systemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket2
     */
    'tariffCode'?: string;
}
/**
 * Statut de validité du stationnement contrôlé
 * @export
 * @enum {string}
 */

export const Validity = {
    PENDING: 'PENDING',
    VALID: 'VALID',
    INVALID: 'INVALID'
} as const;

export type Validity = typeof Validity[keyof typeof Validity];


/**
 * 
 * @export
 * @interface VehicleTypeRecord
 */
export interface VehicleTypeRecord {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeRecord
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeRecord
     */
    'value'?: string;
}

/**
 * ControlApi - axios parameter creator
 * @export
 */
export const ControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resulting FPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultFps} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emitFps: async (controlId: string, body?: ControlResultFps, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('emitFps', 'controlId', controlId)
            const localVarPath = `/api/control/{controlId}/emit-fps`
                .replace(`{${"controlId"}}`, encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resulting NFPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultNfps} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emitNfps: async (controlId: string, payload?: ControlResultNfps, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('emitNfps', 'controlId', controlId)
            const localVarPath = `/api/control/{controlId}/emit-nfps`
                .replace(`{${"controlId"}}`, encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Asks to be assigned to an available control
         * @param {number} [force] If \&#39;1\&#39;, finds a new control for user even if he already has one assigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl: async (force?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update control metadata
         * @param {string} controlId Control ID
         * @param {ControlAdditionalData} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveControl: async (controlId: string, body?: ControlAdditionalData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('saveControl', 'controlId', controlId)
            const localVarPath = `/api/control/{controlId}`
                .replace(`{${"controlId"}}`, encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resulting agent mobilisation from control review
         * @param {string} controlId Control ID
         * @param {object} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFollower: async (controlId: string, payload?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('sendFollower', 'controlId', controlId)
            const localVarPath = `/api/control/{controlId}/send-follower`
                .replace(`{${"controlId"}}`, encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Skip current control
         * @param {string} controlId Control ID
         * @param {SkipControlBody} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipControl: async (controlId: string, payload?: SkipControlBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlId' is not null or undefined
            assertParamExists('skipControl', 'controlId', controlId)
            const localVarPath = `/api/control/{controlId}/skip`
                .replace(`{${"controlId"}}`, encodeURIComponent(String(controlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlApi - functional programming interface
 * @export
 */
export const ControlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resulting FPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultFps} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emitFps(controlId: string, body?: ControlResultFps, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emitFps(controlId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resulting NFPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultNfps} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emitNfps(controlId: string, payload?: ControlResultNfps, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emitNfps(controlId, payload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Asks to be assigned to an available control
         * @param {number} [force] If \&#39;1\&#39;, finds a new control for user even if he already has one assigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControl(force?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControl(force, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update control metadata
         * @param {string} controlId Control ID
         * @param {ControlAdditionalData} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveControl(controlId: string, body?: ControlAdditionalData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Control>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveControl(controlId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resulting agent mobilisation from control review
         * @param {string} controlId Control ID
         * @param {object} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFollower(controlId: string, payload?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFollower(controlId, payload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Skip current control
         * @param {string} controlId Control ID
         * @param {SkipControlBody} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipControl(controlId: string, payload?: SkipControlBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipControl(controlId, payload, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ControlApi - factory interface
 * @export
 */
export const ControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlApiFp(configuration)
    return {
        /**
         * 
         * @summary Resulting FPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultFps} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emitFps(controlId: string, body?: ControlResultFps, options?: any): AxiosPromise<void> {
            return localVarFp.emitFps(controlId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resulting NFPS emission from control review
         * @param {string} controlId Control ID
         * @param {ControlResultNfps} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emitNfps(controlId: string, payload?: ControlResultNfps, options?: any): AxiosPromise<void> {
            return localVarFp.emitNfps(controlId, payload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Asks to be assigned to an available control
         * @param {number} [force] If \&#39;1\&#39;, finds a new control for user even if he already has one assigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl(force?: number, options?: any): AxiosPromise<Control> {
            return localVarFp.getControl(force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update control metadata
         * @param {string} controlId Control ID
         * @param {ControlAdditionalData} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveControl(controlId: string, body?: ControlAdditionalData, options?: any): AxiosPromise<Control> {
            return localVarFp.saveControl(controlId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resulting agent mobilisation from control review
         * @param {string} controlId Control ID
         * @param {object} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFollower(controlId: string, payload?: object, options?: any): AxiosPromise<object> {
            return localVarFp.sendFollower(controlId, payload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Skip current control
         * @param {string} controlId Control ID
         * @param {SkipControlBody} [payload] Action JSON payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipControl(controlId: string, payload?: SkipControlBody, options?: any): AxiosPromise<void> {
            return localVarFp.skipControl(controlId, payload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ControlApi - interface
 * @export
 * @interface ControlApi
 */
export interface ControlApiInterface {
    /**
     * 
     * @summary Resulting FPS emission from control review
     * @param {string} controlId Control ID
     * @param {ControlResultFps} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    emitFps(controlId: string, body?: ControlResultFps, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Resulting NFPS emission from control review
     * @param {string} controlId Control ID
     * @param {ControlResultNfps} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    emitNfps(controlId: string, payload?: ControlResultNfps, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Asks to be assigned to an available control
     * @param {number} [force] If \&#39;1\&#39;, finds a new control for user even if he already has one assigned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    getControl(force?: number, options?: AxiosRequestConfig): AxiosPromise<Control>;

    /**
     * 
     * @summary Update control metadata
     * @param {string} controlId Control ID
     * @param {ControlAdditionalData} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    saveControl(controlId: string, body?: ControlAdditionalData, options?: AxiosRequestConfig): AxiosPromise<Control>;

    /**
     * 
     * @summary Resulting agent mobilisation from control review
     * @param {string} controlId Control ID
     * @param {object} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    sendFollower(controlId: string, payload?: object, options?: AxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @summary Skip current control
     * @param {string} controlId Control ID
     * @param {SkipControlBody} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApiInterface
     */
    skipControl(controlId: string, payload?: SkipControlBody, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ControlApi - object-oriented interface
 * @export
 * @class ControlApi
 * @extends {BaseAPI}
 */
export class ControlApi extends BaseAPI implements ControlApiInterface {
    /**
     * 
     * @summary Resulting FPS emission from control review
     * @param {string} controlId Control ID
     * @param {ControlResultFps} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public emitFps(controlId: string, body?: ControlResultFps, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).emitFps(controlId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resulting NFPS emission from control review
     * @param {string} controlId Control ID
     * @param {ControlResultNfps} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public emitNfps(controlId: string, payload?: ControlResultNfps, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).emitNfps(controlId, payload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Asks to be assigned to an available control
     * @param {number} [force] If \&#39;1\&#39;, finds a new control for user even if he already has one assigned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public getControl(force?: number, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).getControl(force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update control metadata
     * @param {string} controlId Control ID
     * @param {ControlAdditionalData} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public saveControl(controlId: string, body?: ControlAdditionalData, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).saveControl(controlId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resulting agent mobilisation from control review
     * @param {string} controlId Control ID
     * @param {object} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public sendFollower(controlId: string, payload?: object, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).sendFollower(controlId, payload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Skip current control
     * @param {string} controlId Control ID
     * @param {SkipControlBody} [payload] Action JSON payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public skipControl(controlId: string, payload?: SkipControlBody, options?: AxiosRequestConfig) {
        return ControlApiFp(this.configuration).skipControl(controlId, payload, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Used to know current server health status.
         * @summary Public server health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAlive: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Used to know current server health status.
         * @summary Public server health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isAlive(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alive>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isAlive(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Used to know current server health status.
         * @summary Public server health status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAlive(options?: any): AxiosPromise<Alive> {
            return localVarFp.isAlive(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - interface
 * @export
 * @interface DefaultApi
 */
export interface DefaultApiInterface {
    /**
     * Used to know current server health status.
     * @summary Public server health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    isAlive(options?: AxiosRequestConfig): AxiosPromise<Alive>;

}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI implements DefaultApiInterface {
    /**
     * Used to know current server health status.
     * @summary Public server health status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public isAlive(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).isAlive(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Agent self statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentSelfStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stats/agent/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Day\'s statistics grouped by agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDayAgentsStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stats/agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Day\'s statistics grouped by LAPI vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDayLapiStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/stats/lapi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decisions statistics
         * @param {string} startDate Start Date
         * @param {string} endDate End Date
         * @param {'day' | 'hour'} [activity] Activity, by day or by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisionStatistics: async (startDate: string, endDate: string, activity?: 'day' | 'hour', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisionStatistics', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisionStatistics', 'endDate', endDate)
            const localVarPath = `/stats/decisions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Agent self statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentSelfStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentSelfStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentSelfStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Day\'s statistics grouped by agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDayAgentsStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentsStatisticsInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDayAgentsStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Day\'s statistics grouped by LAPI vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDayLapiStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LapiStatisticsInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDayLapiStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Decisions statistics
         * @param {string} startDate Start Date
         * @param {string} endDate End Date
         * @param {'day' | 'hour'} [activity] Activity, by day or by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisionStatistics(startDate: string, endDate: string, activity?: 'day' | 'hour', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecisionsStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisionStatistics(startDate, endDate, activity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Agent self statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentSelfStatistics(options?: any): AxiosPromise<AgentSelfStatistics> {
            return localVarFp.getAgentSelfStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Day\'s statistics grouped by agents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDayAgentsStatistics(options?: any): AxiosPromise<Array<AgentsStatisticsInner>> {
            return localVarFp.getDayAgentsStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Day\'s statistics grouped by LAPI vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDayLapiStatistics(options?: any): AxiosPromise<Array<LapiStatisticsInner>> {
            return localVarFp.getDayLapiStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decisions statistics
         * @param {string} startDate Start Date
         * @param {string} endDate End Date
         * @param {'day' | 'hour'} [activity] Activity, by day or by hour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisionStatistics(startDate: string, endDate: string, activity?: 'day' | 'hour', options?: any): AxiosPromise<DecisionsStatistics> {
            return localVarFp.getDecisionStatistics(startDate, endDate, activity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsApi - interface
 * @export
 * @interface StatisticsApi
 */
export interface StatisticsApiInterface {
    /**
     * 
     * @summary Agent self statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApiInterface
     */
    getAgentSelfStatistics(options?: AxiosRequestConfig): AxiosPromise<AgentSelfStatistics>;

    /**
     * 
     * @summary Day\'s statistics grouped by agents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApiInterface
     */
    getDayAgentsStatistics(options?: AxiosRequestConfig): AxiosPromise<Array<AgentsStatisticsInner>>;

    /**
     * 
     * @summary Day\'s statistics grouped by LAPI vehicles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApiInterface
     */
    getDayLapiStatistics(options?: AxiosRequestConfig): AxiosPromise<Array<LapiStatisticsInner>>;

    /**
     * 
     * @summary Decisions statistics
     * @param {string} startDate Start Date
     * @param {string} endDate End Date
     * @param {'day' | 'hour'} [activity] Activity, by day or by hour
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApiInterface
     */
    getDecisionStatistics(startDate: string, endDate: string, activity?: 'day' | 'hour', options?: AxiosRequestConfig): AxiosPromise<DecisionsStatistics>;

}

/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI implements StatisticsApiInterface {
    /**
     * 
     * @summary Agent self statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getAgentSelfStatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getAgentSelfStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Day\'s statistics grouped by agents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getDayAgentsStatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getDayAgentsStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Day\'s statistics grouped by LAPI vehicles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getDayLapiStatistics(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getDayLapiStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decisions statistics
     * @param {string} startDate Start Date
     * @param {string} endDate End Date
     * @param {'day' | 'hour'} [activity] Activity, by day or by hour
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public getDecisionStatistics(startDate: string, endDate: string, activity?: 'day' | 'hour', options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).getDecisionStatistics(startDate, endDate, activity, options).then((request) => request(this.axios, this.basePath));
    }
}


